import { useTranslation } from "react-i18next";
import TextInput from "../../components/inputs/textInput";
import { useFormik } from "formik";
import * as yup from "yup";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { AgentLLogin } from "../../service/reducers/agents/auth/login";

const SignInForm = ({ setStep }) => {
  const { t } = useTranslation();
  const validationSchema = yup.object({
    login: yup.string().required(t("requiredField")),
    password: yup.string().required(t("requiredField")),
  });
  const formik = useFormik({
    initialValues: {
      login: "",
      password: "",
    },
    validationSchema,
    onSubmit: (values) => {
      signInRequest(values);
    },
  });
  const [currentSignInType, setCurrentSignInType] = useState("agent");
  const dispatch = useDispatch();

  let signInRequest;
  switch (currentSignInType) {
    case "agent":
      signInRequest = (data) => dispatch(AgentLLogin(data));
      break;
    case "employee":
      signInRequest = (data) => dispatch(AgentLLogin(data));
      break;

    case "admin":
      signInRequest = (data) => dispatch(AgentLLogin(data));
      break;
    default:
      signInRequest = null;
  }
  return (
    <form onSubmit={formik.handleSubmit}>
      <h1 className="my-4 text-3xl font-bold text-white">{t("welcome")}</h1>
      <section>
        <h1>{t("signInAs")}</h1>
        <div className="flex items-center gap-2">
          {["agent", "employee"].map((type) => (
            <div key={type} className="flex items-center w-full mb-2">
              <button
                type="button"
                onClick={() => setCurrentSignInType(type)}
                className={`bg-blue-500 w-full block text-white px-4 py-2 rounded ${
                  currentSignInType === type ? "bg-blue-700" : ""
                }`}
              >
                {t(type)}
              </button>
            </div>
          ))}
        </div>
      </section>
      <TextInput
        formik={formik}
        name={"login"}
        label={t("emailOrUserName")}
        placeholder={"hello@gmail.com"}
      />
      <TextInput
        formik={formik}
        name={"password"}
        label={t("password")}
        placeholder={"********"}
        type="password"
      />
      <button onClick={() => setStep("forgotPass")} className="underline-link">
        {t("forgotPassword")}
      </button>
      <button
        type="submit"
        className="w-full px-4 py-2 my-4 transition-colors rounded-lg bg-mainBlue hover:bg-blue-700"
      >
        {t("signIn")}
      </button>
    </form>
  );
};

export default SignInForm;
